import { getNamespacedResource } from "../../SharedStores/util";

const BUILT_IN_FIELD_NAMESPACE = "clientBuiltInField";

const GET_ALL_BUILT_IN_FIELDS = "getAllBuiltInFields";
const GET_BUILT_IN_FIELD_BY_ID = "getBuiltInFieldsById";
const GET_BUILT_IN_FIELD_NAME_BY_ID = "getBuiltInFieldNameById";

const BUILT_IN_FIELD_TYPES = {
    getters: {
        [GET_ALL_BUILT_IN_FIELDS]: getNamespacedResource(BUILT_IN_FIELD_NAMESPACE, GET_ALL_BUILT_IN_FIELDS),
        [GET_BUILT_IN_FIELD_BY_ID]: getNamespacedResource(BUILT_IN_FIELD_NAMESPACE, GET_BUILT_IN_FIELD_BY_ID),
        [GET_BUILT_IN_FIELD_NAME_BY_ID]: getNamespacedResource(BUILT_IN_FIELD_NAMESPACE, GET_BUILT_IN_FIELD_NAME_BY_ID)
    }
};

export { BUILT_IN_FIELD_TYPES, BUILT_IN_FIELD_NAMESPACE };

export function createBuiltInFieldStore(state) {
    return {
        namespaced: true,
        state: state,
        getters: {
            [GET_ALL_BUILT_IN_FIELDS](state) {
                return state.BuiltInFields;
            },
            [GET_BUILT_IN_FIELD_BY_ID](state) {
                return function (fieldId) {
                    return state.BuiltInFields.find((field) => field.PublicId == fieldId);
                };
            },
            [GET_BUILT_IN_FIELD_NAME_BY_ID](state) {
                return function (fieldId) {
                    return state.BuiltInFields.find((field) => field.PublicId == fieldId).Name;
                };
            }
        }
    };
}
